import type { ExpertNewsDTO } from '../api/client/expert-news/expert-news.dto';
import type { MaterialDTO } from '../api/client/news/news.dto';

export const isMaterialDTO = (
  item: MaterialDTO | ExpertNewsDTO,
): item is MaterialDTO =>
  'type' in item &&
  typeof item.type === 'string' &&
  ['news', 'analytics', 'new_object'].includes(item.type);
